
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/hooks/use-toast';

interface WorkPerformanceFormValues {
  produtividade: number;
  foco: number;
  satisfacao: number;
  eficiencia: number;
  estresse: number;
  tarefasConcluidas: string;
  conquistas: string;
  desafios: string;
}

const WorkPerformanceForm = () => {
  const form = useForm<WorkPerformanceFormValues>({
    defaultValues: {
      produtividade: 5,
      foco: 5,
      satisfacao: 5,
      eficiencia: 5,
      estresse: 5,
      tarefasConcluidas: '',
      conquistas: '',
      desafios: '',
    },
  });

  const onSubmit = (data: WorkPerformanceFormValues) => {
    console.log(data);
    // Aqui você enviaria os dados para a API
    toast({
      title: "Registro salvo",
      description: "Seu registro de desempenho foi salvo com sucesso!",
    });
    
    // Reset form
    form.reset({
      produtividade: 5,
      foco: 5,
      satisfacao: 5,
      eficiencia: 5,
      estresse: 5,
      tarefasConcluidas: '',
      conquistas: '',
      desafios: '',
    });
  };

  const metricas = [
    { name: 'produtividade', label: 'Produtividade', description: 'Quanto você produziu em relação ao planejado' },
    { name: 'foco', label: 'Foco', description: 'Capacidade de se manter concentrado nas tarefas' },
    { name: 'satisfacao', label: 'Satisfação', description: 'Nível de contentamento com o trabalho realizado' },
    { name: 'eficiencia', label: 'Eficiência', description: 'Capacidade de realizar tarefas com qualidade e rapidez' },
    { name: 'estresse', label: 'Estresse', description: 'Nível de pressão ou tensão no trabalho' },
  ];

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Registro de Desempenho no Trabalho</CardTitle>
        <CardDescription>
          Avalie seu desempenho profissional diário
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            {metricas.map((metrica) => (
              <FormField
                key={metrica.name}
                control={form.control}
                name={metrica.name as keyof WorkPerformanceFormValues}
                render={({ field }) => (
                  <FormItem>
                    <FormLabel className="flex justify-between">
                      <span>{metrica.label}</span>
                      <span className="text-sm text-muted-foreground">{field.value}/10</span>
                    </FormLabel>
                    <FormControl>
                      <Slider
                        min={1}
                        max={10}
                        step={1}
                        defaultValue={[field.value as number]}
                        onValueChange={(values) => {
                          if (Array.isArray(values) && values.length > 0) {
                            // Ensure we're working with a number
                            const numericValue = Number(values[0]);
                            field.onChange(numericValue);
                          }
                        }}
                      />
                    </FormControl>
                    <FormDescription>{metrica.description}</FormDescription>
                    <FormMessage />
                  </FormItem>
                )}
              />
            ))}

            <FormField
              control={form.control}
              name="tarefasConcluidas"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Tarefas Concluídas</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Liste as tarefas que você concluiu hoje"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="conquistas"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Conquistas</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="O que você conquistou hoje? Quais foram suas vitórias?"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="desafios"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Desafios</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Quais desafios você enfrentou? O que pode melhorar?"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit">Salvar registro</Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default WorkPerformanceForm;
